<template>
  <ModalCouponTransaction
    ref="modal"
    v-if="modalShowCouponTransaction"
    @closeModal="closeModalCouponTransaction"
    @appliedCoupons="setAppliedCoupons"
    :customerCoupons="customer_coupons"
  />
  <ModalFindCustomer
    ref="modal"
    v-if="modalShowFindCustomer"
    @closeModal="closeModalFindCustomer"
    @customer-selected="selectCustomer"
  />
  <Card card_class="backdrop-blur-none">
    <router-link to="/transaction" id="back" class="block">
      &#10094; Back
    </router-link>
    <AlertSuccess v-if="alert_success" :text="alert_text" alert_class="mt-8" />
    <AlertDanger
      v-if="alert_danger"
      :text="alert_text"
      alert_class="mt-8"
      @closeAlertDanger="hideAlertDanger"
    />
    <section
      class="p-2 md:p-6 flex justify-center items-center w-full max-w-5xl mx-auto min-h-[calc(100dvh-100px)] pb-12"
    >
      <div class="grid grid-cols-12 md:gap-8 mb-8 w-full">
        <h1 class="col-span-12 font-bold text-2xl">New Transaction</h1>
        <div class="col-span-12 md:col-span-6">
          <Card card_class="md:mt-0 backdrop-blur-lg h-fit">
            <div class="gap-4 grid grid-cols-5">
              <div class="col-span-3">
                <InputForm
                  id="transaction-date"
                  input_class="w-full"
                  label="Transaction Date"
                  label_class="mb-1 block text-start"
                  type="date"
                  v-model="transaction.transaction_date"
                />
              </div>
              <div class="col-span-2">
                <Select
                  label="Branch"
                  id="transaction-branch"
                  option_placeholder="Select Branch"
                  select_class="w-full"
                  valueKey="id"
                  labelKey="name"
                  :options="allBranches"
                  v-model="transaction.branch_id"
                />
              </div>
            </div>
            <Card
              card_class="backdrop-blur-lg mt-2"
              card_body_class="gap-4 grid grid-cols-6"
            >
              <div
                :class="
                  customer_coupons.length > 0 ? 'col-span-4' : 'col-span-4'
                "
              >
                <div>
                  <InputLabel
                    labelClass=""
                    forId="lblCustomerName"
                    label="Customer"
                  />
                  <p class="text-xl text-white font-bold">
                    {{ this.customer_name }}
                  </p>
                </div>
              </div>
              <!-- <div
                v-if="customer_coupons.length > 0"
                :class="
                  customer_coupons.length > 0 ? 'col-span-2 flex items-end' : ''
                "
              >
                <Button
                  @click="showModalCoupons(customer_coupons)"
                  class="w-full"
                  button_text="Coupon"
                />
              </div> -->
              <div class="col-span-2 flex items-end">
                <Button
                  button_id="find-customer"
                  button_text="Select"
                  @click="showModalFindCustomer()"
                  class="w-full"
                />
              </div>
            </Card>
          </Card>

          <Card
            class="col-span-6 lg:col-span-6 mt-4 backdrop-blur-none"
            card_title="Product list"
          >
            <div
              class="flex flex-col gap-2 pr-2 max-h-[400px] lg:max-h-[400px] md:max-h-[600px] overflow-y-scroll"
            >
              <Select
                id="transaction-branch"
                option_placeholder="All category"
                :option_placeholder_disabled="false"
                :option_placeholder_selected="false"
                select_class="w-full"
                valueKey="id"
                labelKey="name"
                :options="allCategories"
                v-model="filter.category"
                @update:modelValue="filterByCategory"
              />

              <template v-for="(product, index) in all_products" :key="index">
                <Card
                  card_class="backdrop-blur-lg"
                  card_body_class="flex justify-between gap-4"
                >
                  <div class="backdrop-blur-xl">
                    <h5 class="font-semibold">{{ product.products_name }}</h5>
                    <p class="text-white/80 font-normal text-base">
                      {{ formatRupiah(product.price) }}
                    </p>
                  </div>
                  <div class="grid place-items-center">
                    <Button
                      @click="addProductToOrderList(product)"
                      class=""
                      button_text="Add &#10095;"
                    />
                  </div>
                </Card>
              </template>
            </div>
          </Card>
        </div>
        <div class="col-span-12 md:col-span-6">
          <div class="flex flex-col justify-between h-full">
            <Card
              card_class="col-span-6 lg:col-span-6 md:mt-0 mt-4 flex-grow"
              card_title="Order List"
              card_body_class="h-full overflow-y-auto pr-2"
            >
              <div class="flex flex-col gap-2 h-full">
                <template v-for="(order, index) in order_list" :key="index">
                  <Card
                    card_class="backdrop-blur-lg"
                    card_body_class="flex justify-between gap-2"
                  >
                    <div class="product-detail flex flex-col w-full">
                      <div
                        class="product-price flex justify-between font-semibold"
                      >
                        <div class="flex flex-col gap-1">
                          <p class="text-start">{{ order.products_name }}</p>
                          <p class="text-white/80 font-normal text-base">
                            {{ formatRupiah(order.price) }}
                          </p>
                        </div>
                        <div class="product-qty flex justify-between">
                          <input
                            v-model="order.quantity"
                            :id="`product-quantity-${index}`"
                            type="text"
                            class="bg-transparent border border-white rounded-md w-16 placeholder:text-white/80 placeholder:text-sm px-1 text-center"
                            value="1"
                          />
                        </div>
                      </div>
                    </div>
                    <div
                      @click="deleteSelectedProduct(order)"
                      class="grid place-items-center bg-white/40 rounded-md cursor-pointer"
                    >
                      <button
                        id="cancel-button"
                        class="py-1 px-2 rounded-lg grid place-items-center"
                      >
                        <XMarkIcon class="h-5 w-5 text-white" />
                      </button>
                    </div>
                  </Card>
                </template>

                <div
                  v-if="customer_coupons.length > 0"
                  :class="
                    customer_coupons.length > 0
                      ? 'col-span-2 flex items-end'
                      : ''
                  "
                >
                  <Button
                    @click="showModalCoupons(customer_coupons)"
                    class="w-full"
                    button_text="Use Coupon"
                  />
                </div>

                <Card
                  v-if="coupons_generated_from_transaction.length > 0"
                  class="col-span-6 mt-4"
                  card_title="Coupons Generated"
                  card_body_class="flex flex-col gap-2 max-h-52 overflow-y-auto"
                >
                  <div
                    v-for="(
                      coupon, index
                    ) in coupons_generated_from_transaction"
                    :key="index"
                    class="flex gap-2"
                  >
                    <Coupon
                      :coupon_discount="coupon.discount"
                      :coupon_expired_date="
                        calculateExpiryDate(
                          parseInt(
                            coupon.expiry_period_per_branch[0].expire_days
                          ) + 1
                        )
                      "
                      :coupon_product_name="coupon.name"
                      :coupon_max_usage="coupon.max_usage"
                      :coupon_on_percentage="coupon.on_percentage"
                      coupon_usage_count=""
                      class="flex-grow"
                    />
                    <button
                      @click="deleteCoupon(coupon)"
                      :id="'delete-coupon-' + index"
                      class="bg-white/30 rounded border border-white/60 py-1 px-2 text-xs"
                    >
                      <TrashIcon class="h-5 w-5 text-black/50 inline-flex" />
                    </button>
                  </div>
                </Card>
              </div>
            </Card>

            <Card
              card_class="mt-4 col-span-6 backdrop-blur-lg"
              card_body_class="flex flex-col"
            >
              <div class="flex justify-between font-bold">
                <h4>Subtotal:</h4>
                <h4>{{ formatRupiah(subtotal) }}</h4>
              </div>
              <div class="flex justify-between font-bold">
                <h4>Discount:</h4>
                <h4>{{ formatRupiah(totalDiscount) }}</h4>
              </div>
              <div class="flex justify-between font-bold text-xl">
                <h4>Grand Total:</h4>
                <h4>{{ formatRupiah(grand_total) }}</h4>
              </div>
            </Card>
          </div>
        </div>
        <div class="col-span-12 flex justify-end mt-4">
          <div class="flex items-center gap-4">
            <CancelButton to_url="/transaction" />
            <span>
              <SubmitButton
                @click="submit"
                :is_loading="loadingSubmit"
                :is_disabled="loadingSubmit"
                id="submit"
                button_text="Save Transaction"
              />
            </span>
          </div>
        </div>
      </div>
    </section>
  </Card>
</template>

<script>
import Card from "@/components/organisms/Card.vue";
import InputForm from "@/components/form/InputForm.vue";
import Select from "@/components/form/Select.vue";
import SubmitButton from "@/components/form/SubmitButton.vue";
import Button from "@/components/buttons/Button.vue";
import CancelButton from "@/components/buttons/CancelButton.vue";
import AlertSuccess from "@/components/alerts/AlertSuccess.vue";
import AlertDanger from "@/components/alerts/AlertDanger.vue";
import ModalCouponTransaction from "@/components/modals/ModalCouponTransaction.vue";
import { XMarkIcon, TrashIcon } from "@heroicons/vue/24/solid";
import { mapGetters, mapActions } from "vuex";
import { formatRupiah } from "@/helpers/formating";
import ModalFindCustomer from "@/components/modals/ModalFindCustomer.vue";
import InputLabel from "@/components/form/InputLabel.vue";
import Coupon from "@/components/molecules/Coupon.vue";

export default {
  name: "AddEditTransaction",
  data() {
    return {
      alert_success: false,
      alert_danger: false,
      alert_text: "",
      loadingSubmit: false,
      modalShowCouponTransaction: false,
      modalShowFindCustomer: false,

      grand_total: 0,
      subtotal: 0,
      totalDiscount: 0,

      transaction: {
        transaction_date: new Date().toISOString().split("T")[0], // Set default to today's date
        branch_id: "",
        customer_id: "",
        products: [],
      },

      filter: {
        category: "",
      },

      order_list: [],
      all_coupons: [],
      all_products: [],
      applied_coupons: null,
      customer_coupons: [],
      coupons_generated_from_transaction: [],
      customer_name: "",
    };
  },
  components: {
    Card,
    InputForm,
    Select,
    SubmitButton,
    CancelButton,
    AlertSuccess,
    AlertDanger,
    Button,
    ModalCouponTransaction,
    XMarkIcon,
    TrashIcon,
    ModalFindCustomer,
    InputLabel,
    Coupon,
  },
  async created() {
    await this.$store.dispatch("customers/fetchAllCustomers");
    await this.$store.dispatch("branches/fetchBranches");
    await this.$store.dispatch("products/fetchProducts");
    await this.$store.dispatch("coupons/fetchCoupons");
    await this.$store.dispatch("categories/fetchCategories");

    this.all_products = this.allProducts;
    this.all_coupons = this.allCoupon;
  },
  computed: {
    ...mapGetters("customers", ["allCustomers"]),
    ...mapGetters("products", ["allProducts"]),
    ...mapGetters("branches", ["allBranches"]),
    ...mapGetters("coupons", ["allCoupon"]),
    ...mapGetters("categories", ["allCategories"]),
    ...mapGetters("coupon_transactions", ["allCouponTransactions"]),
  },
  watch: {
    order_list: {
      deep: true,
      handler(newOrderList) {
        this.updateGrandTotal();

        // Update coupon quantity based on product quantity changes
        newOrderList.forEach((product) => {
          const matchingCoupon = this.coupons_generated_from_transaction.find(
            (coupon) => coupon.product_id == product.id
          );
          // console.log("matching coupon: ", matchingCoupon);

          if (matchingCoupon) {
            matchingCoupon.quantity = product.quantity;
          }
        });
      },
    },
    "transaction.customer_id": {
      handler(newCustomerId) {
        if (newCustomerId) {
          this.fetchCustomerCoupons(newCustomerId);
        }
      },
      immediate: true,
    },
  },
  methods: {
    formatRupiah,
    ...mapActions("coupons", ["fetchCouponId"]),
    ...mapActions("transactions", ["createTransaction"]),
    ...mapActions("coupon_transactions", [
      "fetchCouponTransactionByCustomerId",
    ]),

    filterByCategory(categoryId) {
      this.filter.category = categoryId;
      if (categoryId) {
        this.all_products = this.allProducts.filter((product) =>
          product.categories
            ? product.categories.some((category) => category.id == categoryId)
            : false
        );
      } else {
        this.all_products = this.allProducts;
      }
    },

    async fetchCustomerCoupons(customerId) {
      this.customer_coupons = [];
      try {
        const customerCoupons = await this.fetchCouponTransactionByCustomerId(
          customerId
        );
        const couponsByCustomerId = customerCoupons.data;

        const today = new Date();
        today.setHours(0, 0, 0, 0);

        this.customer_coupons = couponsByCustomerId.filter(
          (couponTransaction) => {
            // Pastikan usage_count <= max_usage, expired_date >= tanggal sekarang, dan max_usage == null (unlimited)
            const maxUsageValid =
              couponTransaction.max_usage == null ||
              couponTransaction.usage_count < couponTransaction.max_usage;

            const couponExpiryDate = new Date(couponTransaction.expired_date);
            couponExpiryDate.setHours(0, 0, 0, 0);

            const notExpired = couponExpiryDate >= today;

            // console.log('maxUsageValid', maxUsageValid);
            // console.log('notExpired', notExpired);

            return maxUsageValid && notExpired;
          }
        );
      } catch (error) {
        console.error("Error fetching coupons:", error);
      }

      // console.log('this.customer_coupons: ', this.customer_coupons);
    },
    updateGrandTotal() {
      let subtotal = 0;
      let totalDiscount = 0;

      console.log("this.order_list: ", this.order_list);

      this.grand_total = this.order_list.reduce((total, product) => {
        let priceAfterDiscount = product.price;
        console.log("product: ", product);

        // Calculate subtotal
        subtotal += product.price * product.quantity;

        // Check if coupon is applied and calculate discounted price
        if (product.use_coupon && product.discount) {
          if (product) priceAfterDiscount -= product.discount;
          totalDiscount += product.discount * product.quantity;
        }

        return total + priceAfterDiscount * product.quantity;
      }, 0);

      this.grand_total = Math.max(this.grand_total, 0);

      // Assign calculated values to data properties
      this.subtotal = subtotal;
      this.totalDiscount = totalDiscount;
    },
    addProductToOrderList(product) {
      // console.log('order_list: ', this.order_list);

      if (product.promos) {
        product.promos.forEach(async (promo) => {
          let response = await this.fetchCouponId(promo.coupon_id);
          // console.log('response from fetchCoupons: ', response.data);

          const existingCoupon = this.coupons_generated_from_transaction.find(
            (coupon) =>
              coupon.product_id == product.id && coupon.id == response.data.id
          );

          if (existingCoupon) {
            existingCoupon.quantity + 1;
          } else {
            this.coupons_generated_from_transaction.push({
              ...response.data,
              quantity: 1,
              product_id: product.id,
            });
          }
        });
      }

      const sameProduct = this.order_list.find(
        (order) => order.id == product.id
      );
      // Cek apabila produk yang ditambahkan ke order_list sama, maka tambahan qty-nya
      if (product.id == sameProduct?.id) {
        this.order_list.find((order) => order.id == product.id).quantity++;
      } else {
        this.order_list.push({
          ...product,
          quantity: 1,
          use_coupon: null,
          coupon_transaction_id: null,
        });
      }

      // this.all_products = this.all_products.filter(prod => prod.id != product.id);
      this.updateGrandTotal();
    },
    deleteSelectedProduct(order) {
      this.order_list = this.order_list.filter(
        (product) => product.id != order.id
      );
      this.coupons_generated_from_transaction =
        this.coupons_generated_from_transaction.filter(
          (coupon) => coupon.product_id != order.id
        );
      this.updateGrandTotal();
    },
    deleteCoupon(coupon) {
      this.coupons_generated_from_transaction =
        this.coupons_generated_from_transaction.filter(
          (c) => c.id != coupon.id
        );
    },
    // Menyimpan kupon yang diterapkan ke state applied_coupons
    setAppliedCoupons(selectedCoupons) {
      // Update each product in order_list if coupon applies
      this.order_list = this.order_list.map((product) => {
        const matchingCoupon = selectedCoupons.find(
          (coupon) => coupon.product_id == product.id
        );

        if (matchingCoupon) {
          return {
            ...product,
            use_coupon: true,
            coupon_transaction_id: matchingCoupon.id,
            discount: matchingCoupon?.Coupon?.on_percentage
              ? product.price * (matchingCoupon.discount / 100)
              : matchingCoupon.discount, // Apply the discount from coupon
          };
        }

        return product;
      });

      this.updateGrandTotal();
    },
    async submit() {
      if (!this.transaction.transaction_date) {
        this.showAlert("failed", "Transaction date cannot be empty!");
        return;
      }
      if (!this.transaction.customer_id) {
        this.showAlert("failed", "Customer cannot be empty!");
        return;
      }
      if (!this.transaction.branch_id) {
        this.showAlert("failed", "Branch cannot be empty!");
        return;
      }
      if (!this.transaction.products.length <= 0) {
        this.showAlert("failed", "Products cannot be empty!");
        return;
      }

      // Mempersiapkan data produk untuk transaksi
      this.transaction.products = this.order_list.map((product) => {
        const hasGeneratedCoupon = this.coupons_generated_from_transaction.some(
          (coupon) => coupon.product_id == product.id
        );

        // Hanya tambahkan satu entri untuk setiap product_id di promos, meskipun quantity > 1
        const promos = hasGeneratedCoupon
          ? product.promos.flatMap((promo) => {
              const coupon = this.all_coupons.find(
                (c) => c.id == promo.coupon_id
              );

              if (coupon && coupon.expiry_period_per_branch) {
                // Cocokkan branch_id dengan transaction.branch_id
                const matchingBranch = coupon.expiry_period_per_branch.find(
                  (branch) => branch.branch_id == this.transaction.branch_id
                );

                if (matchingBranch) {
                  const existingPromo = product.promos.find(
                    (existing) => existing.product_id === product.id
                  );

                  if (!existingPromo) {
                    return {
                      expire_days: parseInt(matchingBranch.expire_days) + 1,
                      branch_id: matchingBranch.branch_id,
                      coupon_id: coupon.id,
                      max_usage: coupon.max_usage,
                      discount: parseInt(coupon.discount),
                      product_id: coupon.product_id || null,
                    };
                  }
                } else {
                  // Walaupun tidak ada matching branch, tetap kasi promo, dengan asumsi semua branch promo nya sama
                  const existingPromo = product.promos.find(
                    (existing) => existing.product_id === product.id
                  );

                  if (
                    !existingPromo &&
                    coupon.expiry_period_per_branch.length > 0
                  ) {
                    return {
                      expire_days:
                        parseInt(
                          coupon.expiry_period_per_branch[0].expire_days
                        ) + 1,
                      branch_id: parseInt(this.transaction.branch_id),
                      coupon_id: coupon.id,
                      max_usage: coupon.max_usage,
                      discount: parseInt(coupon.discount),
                      product_id: coupon.product_id || null,
                    };
                  }
                }
              }
              return []; // Tidak ada branch yang cocok
            })
          : []; // Jika tidak ada coupon yang ter-generate, kosongkan promos

        return {
          id: product.id,
          use_coupon: product.use_coupon,
          coupon_transaction_id: product.coupon_transaction_id,
          quantity: product.quantity,
          products_name: product.products_name,
          description: product.description,
          price: parseInt(product.price),
          reminders: product.reminders
            ? product.reminders.map((reminder) => ({
                ...reminder,
                days: parseInt(reminder.days),
              }))
            : [],
          promos: promos,
        };
      });

      this.transaction.branch_id = parseInt(this.transaction.branch_id);
      this.transaction.customer_id = parseInt(this.transaction.customer_id);

      // console.log('Final Transaction:', this.transaction);

      try {
        this.loadingSubmit = true;
        await this.createTransaction(this.transaction);
        this.loadingSubmit = false;
        this.showAlert("success", "Transaction created sucessfully!");
        this.$router.push({ name: "Transaction" });
      } catch (error) {
        this.loadingSubmit = false;
        console.error(error);
        this.showAlert("failed", "Failed to create transaction!", error);
      }
    },
    showModalCoupons(coupons) {
      this.modalShowCouponTransaction = true;
      this.customer_coupons = coupons;
    },
    closeModalCouponTransaction() {
      this.modalShowCouponTransaction = false;
    },
    hideAlertDanger() {
      this.alert_danger = false;
      this.alert_text = "";
    },
    showAlert(type, text) {
      if (type == "success") {
        this.alert_success = true;
        this.alert_text = text;
      } else {
        this.alert_danger = true;
        this.alert_text = text;
      }
      setTimeout(() => {
        this.alert_success = false;
        this.alert_danger = false;
        this.alert_text = "";
      }, 2000);
    },

    showModalFindCustomer() {
      this.modalShowFindCustomer = true;
    },

    async closeModalFindCustomer() {
      this.modalShowFindCustomer = false;
    },

    selectCustomer(customer) {
      this.transaction.customer_id = customer.id;
      this.customer_name = customer.name;
      // console.log(this.transaction);
    },

    calculateExpiryDate(expireDays) {
      const transactionDate = new Date(this.transaction.transaction_date);
      transactionDate.setDate(transactionDate.getDate() + parseInt(expireDays));
      return transactionDate.toISOString().split("T")[0]; // Returns date in YYYY-MM-DD format
    },
  },
};
</script>
